// An identifier nobody can read — the same shapes the API's
// commandCenter/recipientNames.ts refuses to print: uuid, ULID, a long hex run,
// a bare number of five or more digits.
//
// Two uses, both deliberate. Display text is asserted against it in
// noIds.test.ts — that is the guard. And a composition point that assembles a
// label out of a `??` chain ending in a stored key (RequestsPage's `partyLabel`)
// tests the last resort with it before printing, so a recipient shape nobody
// anticipated degrades to a generic word instead of leaking. A component that
// simply renders a name it was given needs neither.
export const OPAQUE_ID_RE =
  /\b(?:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}|[0-9A-HJKMNP-TV-Z]{26}|[0-9a-f]{20,})\b/i;
